// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__l0ngD","disabled":"Input_disabled__8BJuD","input":"Input_input__BIYMW","label":"Input_label__5QxcH","count":"Input_count__dqCZn"};